import styled from "styled-components";


export const EditTitle = styled.div`
width: 90%;
display: flex;
justify-content: space-between;
align-items: center;
padding-top: 20px;
padding-bottom: 20px;

`
export const Title = styled.div`
margin-left: 35px;
display: flex;
flex-direction: column;
justify-content:flex-start;
align-items: flex-start;
color: var(--Dark-Blue-100, #002E5C);
font-size: 20px;
font-weight: 700;
line-height: 32px;
span{
    font-size: 16px;
font-weight: 500;
line-height: 32px; 
}

`
export const CampainName=styled.span`
font-size: 20px;
font-style: normal;
font-weight: 500;
line-height: 32px; 
`